module.exports = __webpack_public_path__ + "img/secure-1.9c05fc22.png";